// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class QuoteBulkPriceUpdatePreviewStats {
  readonly affectedQuoteCount: number;
  readonly affectedQuoteProductCount: number;
  readonly currentTotalPrice: string;
  readonly increasedTotalPrice: string;
  readonly totalIncreaseAmount: string;

  constructor(data: { [key: string]: any } = {}) {
    this.affectedQuoteCount = data.affectedQuoteCount === undefined ? 0 : data.affectedQuoteCount;
    this.affectedQuoteProductCount =
      data.affectedQuoteProductCount === undefined ? 0 : data.affectedQuoteProductCount;
    this.currentTotalPrice = data.currentTotalPrice === undefined ? '0' : data.currentTotalPrice;
    this.increasedTotalPrice =
      data.increasedTotalPrice === undefined ? '0' : data.increasedTotalPrice;
    this.totalIncreaseAmount =
      data.totalIncreaseAmount === undefined ? '0' : data.totalIncreaseAmount;
  }

  static zero(): QuoteBulkPriceUpdatePreviewStats {
    const zeroValues: ExcludeMethodsDeep<QuoteBulkPriceUpdatePreviewStats> = {
      affectedQuoteCount: 0,
      affectedQuoteProductCount: 0,
      currentTotalPrice: '0',
      increasedTotalPrice: '0',
      totalIncreaseAmount: '0',
    };
    return new QuoteBulkPriceUpdatePreviewStats(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteBulkPriceUpdatePreviewStatsWireFormat = {
  affectedQuoteCount: number;
  affectedQuoteProductCount: number;
  currentTotalPrice: string;
  increasedTotalPrice: string;
  totalIncreaseAmount: string;
};

type NewQuoteBulkPriceUpdatePreviewStatsProps = PartialDeep<
  QuoteBulkPriceUpdatePreviewStats,
  { recurseIntoArrays: true }
>;
export const NewQuoteBulkPriceUpdatePreviewStats: (
  props: NewQuoteBulkPriceUpdatePreviewStatsProps,
) => QuoteBulkPriceUpdatePreviewStats = (props) => new QuoteBulkPriceUpdatePreviewStats(props);

type NewQuoteBulkPriceUpdatePreviewStatsFromWireFormatProps = PartialDeep<
  QuoteBulkPriceUpdatePreviewStatsWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteBulkPriceUpdatePreviewStatsFromWireFormat: (
  props: NewQuoteBulkPriceUpdatePreviewStatsFromWireFormatProps,
) => QuoteBulkPriceUpdatePreviewStats = (props) => new QuoteBulkPriceUpdatePreviewStats(props);
